import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { discount, inr, PLACEHOLDER } from "@/lib/api";

export function ProductCard({ p, i = 0 }) {
  const d = discount(p);
  const soldOut = !p.stock || p.stock <= 0;
  return (
    <Link to={`/record/${p.id}`} className="group relative block rise hover:z-20" style={{ animationDelay: `${(i % 12) * 40}ms` }} data-testid={`product-card-${p.id}`}>
      <div className="relative aspect-square">
      {p.kind !== "gear" && <span className="vinyl-peek" aria-hidden="true" />}
      <div className="relative z-10 h-full bg-white border border-[#e3e3e3] overflow-hidden transition-[border-color] duration-200 group-hover:border-black">
        <img src={p.image || PLACEHOLDER} alt={`${p.artist} – ${p.title}`} loading="lazy"
          onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
          className={`w-full h-full ${p.kind === "gear" ? "object-contain" : "object-cover"} ${soldOut ? "opacity-60" : ""}`} />
        {soldOut ? (
          <span className="absolute top-2.5 left-2.5 bg-[#2b2b2b] text-white text-[10px] font-bold font-arial px-1.5 py-0.5 tracking-wide" data-testid="product-card-soldout">SOLD OUT</span>
        ) : d > 0 && (
          <span className="absolute top-2.5 left-2.5 bg-red text-white text-[10px] font-bold font-arial px-1.5 py-0.5" data-testid="product-card-discount">-{d}%</span>
        )}
        {p.kind !== "gear" && <span className="absolute bottom-2.5 right-2.5 bg-white/90 text-[10px] font-bold font-arial px-1.5 py-0.5">{p.format || "LP"}</span>}
      </div>
      </div>
      <div className="pt-3.5">
        <p className="font-arial font-bold uppercase text-[13px] tracking-wide leading-snug line-clamp-1">{p.artist}</p>
        <p className="text-[13px] text-[#333] leading-snug mt-1 line-clamp-2">
          {p.title}{p.edition && <span className="text-[#9a9a9a]"> · {p.edition}</span>}
        </p>
        <p className="mt-3 font-arial">
          <span className="text-red font-bold text-[14px]" data-testid="product-card-price">{inr(p.price)}</span>
          {p.regular_price && <span className="ml-2 text-[11px] text-[#9a9a9a] line-through">{inr(p.regular_price)}</span>}
        </p>
      </div>
    </Link>
  );
}

export function ProductGrid({ products, testid = "product-grid" }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-5 gap-y-10" data-testid={testid}>
      {products.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
    </div>
  );
}

export function SectionHeading({ label, title, to, id }) {
  return (
    <div className="flex items-end justify-between border-b-2 border-black pb-3 mb-7" data-testid={id}>
      <div>
        {label && <p className="label-caps text-[11px] text-red mb-1.5">{label}</p>}
        <h2 className="font-head font-extrabold text-2xl sm:text-[28px] tracking-tight">{title}</h2>
      </div>
      {to && (
        <Link to={to} className="group flex items-center gap-1.5 text-sm font-medium hover:text-red" data-testid={id ? `${id}-view-all` : undefined}>
          View all <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </Link>
      )}
    </div>
  );
}
